import React, { useEffect } from "react";
import { 
    Menu, 
    MenuItem, 
    SubMenu, 
    collapsed,
    Sidebar as ProSidebar,
 } from 'react-pro-sidebar';
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Theme } from "../../../components/constants";
import { VEC_ICON_NAME } from "../../../components/icons/constants";
import Icons from "../../../components/icons/Icons";
import { logoutUser } from "../../authentication/AuthenticationSaga";
import './directcss/Sidebar.scss';
import styles from './Sidebar.styles';
import { ShowForAllowedPermissionsOnly } from "../../wrappers/ShowForAllowedPermissionsOnly";
import { PAGE_PATH, PAGE_PERMISSIONS } from "../constants/constant";
import Config from "../../../config.web";
import General from "../../../../libs/utility/General";
import { ShowForAllowedUsersOnly } from "../../wrappers/ShowForAllowedUsersOnly";
import { USER_TYPE } from "../../../../libs/customhooks/constants";

export default function Sidebar({ isMenuActive, onMouseAction, signedInUser, toggled }) {
    
    const location = useLocation();
    const dispatch = useDispatch();
    const { pathname } = location;
    const splitLocation = pathname.split("/");

    return (
        <ProSidebar id="sidebar" toggled={toggled} backgroundColor={Theme.PRIMARY} onMouseEnter={onMouseAction} onMouseLeave={onMouseAction} breakPoint={"lg"} width={"180px"} collapsed={true} >
            <div style={{...styles.sidebarContainer, ...(isMenuActive ? styles.overflowShow : styles.overflowHidden )}}>
                <div style={styles.menuGroupContainer}>
                    <br />
                    <Menu className={'sidebar-menu-css'} >
                        <MenuItem
                            active={splitLocation[1] === ''}
                            component={<Link to={PAGE_PATH.DASHBOARD} />}
                            className={'menu-item'}
                            icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.DASHBOARD_ICON} color={(splitLocation[1] === '') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                            <p>Dashboard</p>
                        </MenuItem>
                        <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.VIEW_FORM}>
                            <MenuItem
                                active={splitLocation[1] === 'forms'}                                
                                component={<Link to="/forms/listing/form1099" />}
                                icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.FORMS_ICON} color={(splitLocation[1] === 'forms') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                <p>Forms</p>
                            </MenuItem>
                        </ShowForAllowedPermissionsOnly>
                        <ShowForAllowedUsersOnly>
                            {
                                !signedInUser?.IsDisableBoi && <MenuItem
                                    className={"double-line-label-menu-item"}
                                    style={{ height: "auto" }}
                                    active={splitLocation[1] === 'boireporting'}
                                    component={<Link to="/boireporting" />}
                                    icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.FINCEN_BOI_SIDEBAR_ICON} color={(splitLocation[1] === 'boireporting') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                    <p>FINCEN BOI <br />Reporting</p>
                                </MenuItem>
                            
                            }
                        </ShowForAllowedUsersOnly>
                        <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.VIEW_PAYER}>
                            <MenuItem
                                active={splitLocation[1] === 'payer'}
                                component={<Link to="/payer" />}
                                icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.PAYER_ICON} color={(splitLocation[1] === 'payer') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                <p>Payers</p>
                            </MenuItem>
                        </ShowForAllowedPermissionsOnly>
                        <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.VIEW_RECIPIENT}>
                            <MenuItem
                                active={splitLocation[1] === 'import'}
                                component={<Link to="/import" />}
                                icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.IMPORT_ICON} color={(splitLocation[1] === 'import') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                <p>Integrations</p>
                            </MenuItem>
                        </ShowForAllowedPermissionsOnly>
                        <MenuItem
                            active={splitLocation[1] === 'recipient'}
                            component={<Link to="/recipient" />}
                            icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.RECIPIENT_ICON} color={(splitLocation[1] === 'recipient') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                            <p>Recipients</p>
                        </MenuItem>
                        <MenuItem
                            active={splitLocation[1] === 'history'}
                            component={<Link to="/history" />}
                            icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.HISTORY_ICON} color={(splitLocation[1] === 'history') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                            <p>History</p>
                        </MenuItem>
                        <MenuItem
                            active={splitLocation[1] === 'reports'}
                            component={<Link to="/reports" />}
                            icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.REPORTS_ICON} color={(splitLocation[1] === 'reports') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                            <p>Reports</p>
                        </MenuItem>
                        <ShowForAllowedUsersOnly allowedUsers={[USER_TYPE.ENTERPRISE_USER]}>
                            <MenuItem
                                active={splitLocation[1] === 'notices'}
                                component={<Link to="/notices" />}
                                icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.NOTICES_ICON} color={(splitLocation[1] === 'notices') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                <p>Notices</p>
                            </MenuItem>
                        </ShowForAllowedUsersOnly>
                        <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.VIEW_USER}>
                            <MenuItem
                                active={splitLocation[1] === 'users'}
                                component={<Link to="/users" />}
                                icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.USERS_ICON} color={(splitLocation[1] === 'users') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                <p>Users</p>
                            </MenuItem>
                        </ShowForAllowedPermissionsOnly>
                        <ShowForAllowedUsersOnly allowedUsers={[USER_TYPE.ENTERPRISE_USER, USER_TYPE.ESSENTIAL_USER]}>
                            <MenuItem
                                active={splitLocation[1] === 'api'}
                                component={<Link to="/api" />}
                                icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.API_ICON} color={(splitLocation[1] === 'api') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                                <p>API</p>
                            </MenuItem>
                        </ShowForAllowedUsersOnly>
                        <MenuItem
                            active={splitLocation[1] === 'support'}
                            component={<Link to="/support" />}
                            icon={<Icons familyName='vec' iconName={VEC_ICON_NAME.SUPPORT_ICON} color={(splitLocation[1] === 'support') ? Theme.MENU_ICONS_ACTIVE : Theme.ICONS_PRIMARY} />}>
                            <p>Support</p>
                        </MenuItem>
                    </Menu>
                </div>
            </div>
        </ProSidebar>
    )
}